package com.exura.features.legacyplans.domain.usecase

import com.exura.features.legacyplans.domain.mapper.toDetailedPlan
import com.exura.features.legacyplans.domain.repository.DetailedPlanRepository
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import kotlinx.datetime.LocalDateTime

class SaveDetailedPlanUseCase(
    private val detailedPlanRepository: DetailedPlanRepository,
) {
    /**
     * Converts a BasePlan to DetailedPlan and saves it to the repository
     * @param basePlan The base plan to convert
     * @param startDate The start date for the detailed plan
     * @return Result containing the saved DetailedPlan with its new document ID
     */
    suspend operator fun invoke(
        basePlan: BasePlan,
        startDate: LocalDateTime,
    ): Result<String> = runCatching {
        // Convert BasePlan to DetailedPlan
        val detailedPlan = basePlan.toDetailedPlan(startDate)
        // Save to repository
        val savedPlan = detailedPlanRepository.create(detailedPlan).getOrThrow()

        // Return the document ID
        savedPlan.firebaseDocId!!
    }
}
